module.exports = __webpack_public_path__ + "static/img/charge.a9554629.png";